import { Controller } from '@hotwired/stimulus'

// Pushes micro-conversion events into the GTM dataLayer (GA4 picks them up
// via GTM triggers). Attached to <body>, it tracks:
//
// - tel: link clicks    -> phone_click
// - mailto: link clicks -> email_click
// - any element tagged with data-analytics-event (+ data-analytics-name)
// - Calendly bookings   -> schedule_booking (postMessage from the widget)
export default class extends Controller {
  connect () {
    this.onClick = this.onClick.bind(this)
    this.onMessage = this.onMessage.bind(this)
    this.element.addEventListener('click', this.onClick, true)
    window.addEventListener('message', this.onMessage)
  }

  disconnect () {
    this.element.removeEventListener('click', this.onClick, true)
    window.removeEventListener('message', this.onMessage)
  }

  onClick (event) {
    if (!event.target || typeof event.target.closest !== 'function') return

    const tagged = event.target.closest('[data-analytics-event]')
    if (tagged) {
      this.push(tagged.dataset.analyticsEvent, {
        cta_name: tagged.dataset.analyticsName,
        link_url: tagged.getAttribute('href') || undefined,
        link_text: this.textOf(tagged)
      })
      return
    }

    const link = event.target.closest('a[href]')
    if (!link) return

    const href = link.getAttribute('href')
    if (href.startsWith('tel:')) {
      this.push('phone_click', { link_url: href, link_text: this.textOf(link) })
    } else if (href.startsWith('mailto:')) {
      this.push('email_click', { link_url: href, link_text: this.textOf(link) })
    }
  }

  onMessage (event) {
    if (event.origin !== 'https://calendly.com') return
    if (event.data && event.data.event === 'calendly.event_scheduled') {
      this.push('schedule_booking', { scheduler: 'calendly' })
    }
  }

  push (eventName, params = {}) {
    if (!eventName) return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName, ...params })
  }

  textOf (element) {
    return (element.textContent || element.value || '').trim().slice(0, 100)
  }
}
